import { mfaApi } from '../../axios.config';

export const state = {
  data: {},
};

export const actions = {
  /**
   * Get MFA status
   * @returns {Promise}
   */
  async getStatus({ commit }) {
    const res = await mfaApi.get('/status');
    commit('updateMfaStatus', res.data.status);
  },

  /**
   * Post MFA
   * @returns {Promise}
   */
  async post({ commit }, params) {
    const res = await mfaApi.post('', params);
    commit('updateMfa', res.data);
  },

  /**
   * Post verify MFA
   * @returns {Promise}
   */
  async postVerify({ dispatch }, params) {
    const res = await mfaApi.post('/verify', params);
    if (!res.data.success) {
      throw new Error('Verification unsuccessful');
    }
    await dispatch('getStatus');
  },

  /**
   * Delete MFA
   * @returns {Promise}
   */
  async delete({ dispatch }) {
    await mfaApi.delete('');
    await dispatch('getStatus');
  },
};

export const mutations = {
  updateMfa(state, data) {
    state.data = {
      ...state.data,
      ...data,
    };
  },
  updateMfaStatus(state, status) {
    state.data = {
      ...state.data,
      status,
    };
  },
};

export const getters = {};
